<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Parametri Vitali</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovaMisurazione" class="mb-2">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>

                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ row.index + 1 }}
                        </template>
                        <template #cell(dataOra)="item">
                            {{ formatDateTime(item.item.createDate) }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-button size="sm" v-b-tooltip.hover title="Visualizza Parametri" variant="outline-secondary" @click="onClickView(item)" class="mr-1 no-text">
                                <font-awesome-icon icon="eye" />
                            </b-button>
                            <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Parametri" @click="onClickAggiornaParametriVitali(item)">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover title="Cancella Paramentro" variant="outline-danger" @click="onClickDeleteParametriVitali(item)">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>

            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <rsa-paziente-parametri-vitali-edit-modal-component ref="mdlRsaPazienteParametriVitaliEdit" @saveSuccess="onSaveSuccess"></rsa-paziente-parametri-vitali-edit-modal-component>
        <rsa-paziente-parametri-vitali-view-modal-component ref="mdlRsaPazienteParametriVitaliView"></rsa-paziente-parametri-vitali-view-modal-component>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
// import axios from "axios";
import RsaPazienteParametriVitaliEditModalComponent from "./RsaPazienteParametriVitaliEditModalComponent.vue";
import RsaPazienteParametriVitaliViewModalComponent from "./RsaPazienteParametriVitaliViewModalComponent.vue";
export default {
    props: {
        // idAccettazione: { type: String }  ,
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    mixins: [UtilityMixin],
    components: { RsaPazienteParametriVitaliEditModalComponent, RsaPazienteParametriVitaliViewModalComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            pathResource: "/rsaparametrivitalitestate",
            linkedit: "/",
            filterItems: [],
            filtroSpesaExtra: {},
            showModalLoading: false,
            idAccettazione: "",
            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 4rem",
                },
                {
                    label: "Descrizione",
                    key: "descrizioneMisurazione",
                    thStyle: "width: 30rem",
                },
                {
                    label: "Data Ora",
                    key: "dataOra",
                    thStyle: "width: 15rem",
                },
                {
                    label: "Note",
                    key: "note",
                },
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    mounted() {},
    methods: {
        loadData(id) {
            let me = this;
            if (id) {
                me.idAccettazione = id;
            }
            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResource, { idAccettazione: me.idAccettazione }, me.loadDataSuccess, me.loadDataError);
            //   this.showModalLoading = true;
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
            //  this.showModalLoading = true;
        },
        loadDataError(response) {
            console.log(response);
        },
        onClickAggiornaParametriVitali(item) {
            let me = this;
            me.$refs.mdlRsaPazienteParametriVitaliEdit.show(item.id);
        },
        onClickDeleteParametriVitali(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Parametri Vitali",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteParametriVitali(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteParametriVitali(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            UtilityMixin.methods.restCallDelete(link, me.resultDeleteResponse, me.resultDeleteError);
        },
        resultDeleteResponse(response) {
            let me = this;
            me.$emit("onDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.loadData();
        },
        resultDeleteError(error) {
            let me = this;
            console.log(error);
            me.showModalLoading = false;
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickView(item) {
            let me = this;
            me.$refs.mdlRsaPazienteParametriVitaliView.show(item.id);
        },
        onClickNuovaMisurazione() {
            let me = this;
            console.log(me.idAccettazione);
            let url = process.env.VUE_APP_PATH_API + "/rsaaccettazioni/" + me.idAccettazione;

            axios
                .get(url)
                .then((response) => {
                    let accettazione = response.data.data;
                    //console.log("Prova ge", accettazione);
                    if (accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" || accettazione.statoAttuale === "ASSENTE") {
                        let messaggio = accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                        me.$bvModal.msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        });
                        return;
                    }
                    me.$refs.mdlRsaPazienteParametriVitaliEdit.show(null);
                })
                .catch((error) => {
                    console.error("Errore nel recupero dati accettazione:", error);
                    me.$bvToast.toast("Errore nel recupero dei dati del paziente.", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("sucessRestCall", response);
            me.$emit("onAfterSave");
            me.loadData();
        },
        saveErrorResponse(response) {
            let me = this;
            if (response.response.status === 400) {
                this.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                me.$bvToast.toast("Errore nel salvataggio" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        onSaveSuccess() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
